module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Thin.2d775c54.svg";